// extracted by mini-css-extract-plugin
export default {"title":"m9-z","warning":"n9-z","sizeOptionsLegendText":"o9-z"};